// extracted by mini-css-extract-plugin
export var button = "LoginButton3-module--button--u3dG4";
export var scaling = "LoginButton3-module--scaling--iHPqi";